exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#App .ie-warning {\n  font-size: 36px;\n  color: red;\n}", ""]);

